import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const MechaMenu = ({ isOpen }) => {
    const menuVariants = {
        hidden: {
            opacity: 0,
            scale: 0.3,
            rotateX: -90,
            y: -100,
            clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)'
        },
        visible: {
            opacity: 1,
            scale: 1,
            rotateX: 0,
            y: 0,
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            transition: {
                duration: 0.6,
                ease: [0.23, 1, 0.320, 1],
                staggerChildren: 0.1,
                delayChildren: 0.2
            }
        },
        exit: {
            opacity: 0,
            scale: 0.3,
            rotateX: -90,
            y: -100,
            clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)',
            transition: {
                duration: 0.4,
                ease: [0.23, 1, 0.320, 1]
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, x: -50, rotateY: -90 },
        visible: { 
            opacity: 1, 
            x: 0, 
            rotateY: 0,
            transition: { duration: 0.3, ease: "easeOut" }
        }
    };

    const menuItems = [
        { to: '/', label: 'HOME', icon: '◉' },
        { to: '/tracks', label: 'TRACKS', icon: '♫' },
        { to: '/about', label: 'ABOUT', icon: '◈' }
    ];

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="mecha-menu"
                    variants={menuVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <div className="menu-frame">
                        <div className="menu-header">
                            <div className="menu-status">SYSTEM ACTIVE</div>
                            <div className="menu-grid">█ █ █</div>
                        </div>
                        
                        <div className="menu-items">
                            {menuItems.map((item, index) => (
                                <motion.div
                                    key={item.to}
                                    variants={itemVariants}
                                    className="menu-item-wrapper"
                                >
                                    <Link to={item.to} className="menu-item">
                                        <span className="menu-icon">{item.icon}</span>
                                        <span className="menu-label">{item.label}</span>
                                        <span className="menu-arrow">→</span>
                                    </Link>
                                </motion.div>
                            ))}
                        </div>
                        
                        <div className="menu-footer">
                            <div className="menu-coords">X:00 Y:00 Z:00</div>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default MechaMenu;